module.exports = __webpack_public_path__ + "img/expired_default.c54ac2ce.png";